module.exports = __webpack_public_path__ + "static/media/dentaldentures02.178b03d9.png";